<template>
  <div id="app">
    <div class="container-top">
      <errors :errored="errored" :message="errorMessage"></errors>
      <search
        @orderNumberSubmitted="findOrderNumber"
        @testOrderResponse="testOrderResponse"
        :loading="loading"
        :data="data"
        :orderNumbers="orderNumbers"
        :holds="orderInfo"
        :canTest="canTest"
        @toggleLoadShipmentModal="toggleLoadShipmentModal"
        :stationId="stationId"
        :loadingConsolidated="loadingConsolidatedOrders"
        @getConsolidatedOrders="getConsolidatedOrders"
      ></search>
      <shipmentAddressDisplay
        :orderInfo="orderInfo"
        @updatedAtn="updateAtn"
        @updatedPhone="updatePhone"
      ></shipmentAddressDisplay>
      <carrierInfo
        :carrierOptions="carrierOptions"
        :selectedCarrier="selectedCarrier"
        :orderInfo="orderInfo"
        :serviceGroupId="serviceGroupId"
        :loading="loadingRates"
        @carrierChanged="changeCarrier"
        @serviceChanged="changeService"
        @returnServiceChanged="changeReturnService"
        @accountChanged="changeAccount"
        @serviceGroupChanged="changeServiceGroup"
        @accountNumberChanged="changeAccountNumber"
        @thirdPartyAccountNumberChanged="changeThirdPartyAccountNumber"
        @signatureChanged="changeSignature"
        @emailChanged="changeEmail"
        @returnLabelChanged="changeReturnLabel"
        @saturdayDeliveryChanged="changeSaturdayDelivery"
        @insuranceChanged="changeInsurance"
        @getRates="getRates"
      ></carrierInfo>
    </div>
    <div class="container-bottom">
      <div class="shipments-container">
        <shipmentContainer
          @addBox="addBox"
          @removeBox="removeBox"
          @updatedWeight="updateWeight"
          :settings="settings"
          :orderInfo="orderInfo"
          :selectedBox="selectedBox"
          :loading="loadingWeight"
          :loadingShipment="loadingShipment"
          @itemMoved="moveItem"
          @toggleStateModal="toggleStateModal"
          @updateBoxType="updateBoxType"
          @addRow="addRow"
          @updateRow="updateRow"
          @cancelUpdate="cancelUpdate"
          @selectedItem="selectedItem"
          @getWeight="getWeight"
          @updateBoxWidth="updateWidth"
          @updateBoxHeight="updateHeight"
          @updateBoxLength="updateLength"
          @createShipment="createShipment"
        ></shipmentContainer>
      </div>
      <international
        :orderInfo="orderInfo"
        @updateValue="updateInternationalValue"
        @updateItn="updateItn"
        @updateDuty="updateDuty"
        @updateCurrency="updateCurrency"
        @updateDescription="updateDescription"
        @updateUnitPrice="updateUnitPrice"
        @updateDutyCountryCode="updateDutyCountryCode"
        @updateDutyPostalCode="updateDutyPostalCode"
        @updateDutyAccount="updateDutyAccount"
      />
    </div>
    <testResponseModal
      @closeTestResponseModal="closeTestResponseModal"
      :testResponse="testResponse"
      :open="testResponseModalOpen"
    ></testResponseModal>
    <loadingReturnRatesModal
      :open="loadingReturnRatesOpen"
    ></loadingReturnRatesModal>
    <ratesModal
      @closeRatesModal="closeRatesModal"
      @rateSelected="rateSelected"
      :rates="rates"
      :open="ratesMenuOpen"
      :loading="loadingRates"
    ></ratesModal>
    <returnRatesModal
      @closeReturnRatesModal="closeReturnRatesModal"
      @returnRateSelected="returnRateSelected"
      :rates="rates"
      :open="returnRatesMenuOpen"
    ></returnRatesModal>
    <consolidatedOrders
      @closeConsolidatedModal="closeConsolidatedModal"
      @ordersSelected="ordersSelected"
      :orders="consolidatedOrders"
      :open="consolidatedOrdersModalOpen"
      :loading="loadingConsolidatedOrders"
      @searchConsolidated="searchConsolidated"
    ></consolidatedOrders>
    <shipmentInfoModal
      :shipmentInfo="shipmentInfo"
      :open="shipmentModalOpen"
    ></shipmentInfoModal>
    <saveStateModal
      :stateName="stateName"
      @changeStateName="changeStateName"
      :open="saveStateModalOpen"
      @updateState="updateState"
      :currentState="currentState"
      @saveState="saveState"
      @toggleSaveStateModal="toggleStateModal"
    ></saveStateModal>
    <loadShipmentModal
      :open="loadShipmentModalOpen"
      @deleteShipment="deleteShipment"
      @loadShipment="loadShipment"
      :savedStates="savedStates"
      @toggleLoadShipmentModal="toggleLoadShipmentModal"
    ></loadShipmentModal>
    <div
      v-if="
        orderInfo &&
          orderInfo.special_items &&
          orderInfo.special_items.hold_ship &&
          orderInfo.special_items.hold_ship.length === 0
      "
      class="complete-form-actions"
    ></div>
  </div>
</template>

<script>
export default {
  data: function() {
    const defaults = JSON.parse(this.defaults_json);
    return {
      savedStates: JSON.parse(this.saved_states),
      orderInfo: null,
      loading: false,
      defaults: defaults,
      settings: JSON.parse(this.settings_json),
      canTest: this.can_test == 'true',
      loadingRates: false,
      loadingWeight: null,
      loadShipmentModalOpen: false,
      consolidatedOrders: [],
      orderNumbers: [{ number: null }],
      shipmentInfo: null,
      stateName: null,
      currentState: null,
      errored: false,
      loadingShipment: false,
      validForm: false,
      shipmentModalOpen: false,
      saveStateModalOpen: false,
      carrierOptions: null,
      loadingConsolidatedOrders: false,
      selectedCarrier: null,
      selectedBox: null,
      serviceGroupId: defaults && defaults.service_group_id,
      stationId: defaults && defaults.station_id,
      testResponse: null,
      rates: [],
      ratesMenuOpen: false,
      returnRatesMenuOpen: false,
      testResponseModalOpen: false,
      loadingReturnRates: false,
      loadingReturnRatesOpen: false,
      consolidatedOrdersModalOpen: false,
      errorMessage: null,
    };
  },
  props: ['data', 'defaults_json', 'settings_json', 'saved_states', 'can_test'],
  methods: {
    testOrderResponse(orderNumbers, stationId) {
      this.stationId = stationId;
      let numbers = this.translateOrderNumbers(orderNumbers);
      if (stationId === null) {
        this.setErrorMessage('Please select a station.');
      } else if (numbers === '') {
        this.setErrorMessage('Please enter a delivery number.');
      } else {
        this.sendTestOrderRequest(numbers, stationId);
      }
    },
    findOrderNumber(orderNumbers, stationId) {
      this.stationId = stationId;
      let numbers = this.translateOrderNumbers(orderNumbers);
      if (stationId === null) {
        this.setErrorMessage('Please select a station.');
      } else if (numbers === '') {
        this.setErrorMessage('Please enter a delivery number.');
      } else {
        this.sendOrderRequest(numbers, stationId);
      }
    },
    changeStateName(name) {
      this.stateName = name;
    },
    getConsolidatedOrders() {
      this.loadingConsolidatedOrders = true;
      this.$http
        .get(
          `${
            window.location.origin
          }/integrated_shipments/consolidated_orders/${new Date()}/${new Date()}`
        )
        .then((result) => {
          this.consolidatedOrders = result.data;
          this.loadingConsolidatedOrders = false;
          this.consolidatedOrdersModalOpen = true;
          this.errored = false;
        })
        .catch((error) => {
          this.setErrorMessage(error.response.data.message);
        });
    },

    loadShipment(id) {
      this.$http
        .get(`${window.location.origin}/integrated_shipping_states/${id}`)
        .then((result) => {
          const state = JSON.parse(result.data.state);
          this.orderInfo = state.orderInfo;
          this.consolidatedOrders = state.consolidatedOrders;
          this.orderNumbers = state.orderNumbers;
          this.shipmentInfo = state.shipmentInfo;
          this.carrierOptions = state.carrierOptions;
          this.currentState = result.data.currentState;
          this.stateName = result.data.currentState.name;
          this.selectedCarrier = state.selectedCarrier;
          this.selectedBox = state.selectedBox;
          this.serviceGroupId = state.serviceGroupId;
          this.stationId = state.stationId;
          this.rates = state.rates;
          this.loadShipmentModalOpen = false;
        })
        .catch((error) => {
          console.log(error);
          // this.setErrorMessage(error.response.data.message);
        });
    },
    saveState() {
      const csrfToken = document.getElementsByTagName('meta')[6].content;
      this.savingState = true;
      this.$http({
        method: 'post',
        url: `${window.location.origin}/integrated_shipping_states`,
        headers: { 'X-CSRF-Token': csrfToken },
        data: {
          state: {
            orderInfo: this.orderInfo,
            consolidatedOrders: this.consolidatedOrders,
            orderNumbers: this.orderNumbers,
            shipmentInfo: this.shipmentInfo,
            carrierOptions: this.carrierOptions,
            selectedCarrier: this.selectedCarrier,
            selectedBox: this.selectedBox,
            serviceGroupId: this.serviceGroupId,
            stationId: this.stationId,
            rates: this.rates,
          },
          location_id: this.orderInfo.location.id,
          name: this.stateName,
        },
      })
        .then((result) => {
          this.savedStates = result.data.savedShipments;
          this.saveStateModalOpen = false;
          this.currentState = result.data.state;
          this.setErrorMessage(result.data.message);
        })
        .catch((error) => {
          this.setErrorMessage(error.response.data.message);
        });
    },

    updateState() {
      const csrfToken = document.getElementsByTagName('meta')[6].content;
      this.savingState = true;
      this.$http({
        method: 'put',
        url: `${window.location.origin}/integrated_shipping_states/${this.currentState.id}`,
        headers: { 'X-CSRF-Token': csrfToken },
        data: {
          state: {
            id: this.currentState.id,
            orderInfo: this.orderInfo,
            consolidatedOrders: this.consolidatedOrders,
            orderNumbers: this.orderNumbers,
            shipmentInfo: this.shipmentInfo,
            carrierOptions: this.carrierOptions,
            selectedCarrier: this.selectedCarrier,
            selectedBox: this.selectedBox,
            serviceGroupId: this.serviceGroupId,
            stationId: this.stationId,
            rates: this.rates,
          },
          location_id: this.orderInfo.location.id,
        },
      })
        .then((result) => {
          this.saveStateModalOpen = false;
          this.setErrorMessage(result.data.message);
        })
        .catch((error) => {
          this.setErrorMessage(error.response.data.message);
        });
    },

    deleteShipment(id) {
      const csrfToken = document.getElementsByTagName('meta')[6].content;
      this.savingState = true;
      this.$http({
        method: 'delete',
        url: `${window.location.origin}/integrated_shipping_states/${id}`,
        headers: { 'X-CSRF-Token': csrfToken },
      })
        .then((result) => {
          this.loadShipmentModalOpen = false;
          this.savedStates = result.data.savedShipments;
          this.setErrorMessage(result.data.message);
          this.syncCurrentState(id);
        })
        .catch((error) => {
          this.setErrorMessage(error.response.data.message);
        });
    },

    syncCurrentState(id) {
      if (this.currentState.id === id) {
        this.currentState = null;
        this.stateName = null;
      }
    },
    createRandomId() {
      return (
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15)
      );
    },
    searchConsolidated(startDate, endDate) {
      this.loadingConsolidatedOrders = true;
      if (startDate > endDate) {
        this.setErrorMessage('Start date must be before end date!');
      } else {
        this.$http
          .get(
            `${window.location.origin}/integrated_shipments/consolidated_orders/${startDate}/${endDate}`
          )
          .then((result) => {
            this.consolidatedOrders = result.data;
            this.loadingConsolidatedOrders = false;
            this.consolidatedOrdersModalOpen = true;
            this.errored = false;
          })
          .catch((error) => {
            this.setErrorMessage(error.response.data.message);
          });
      }
    },
    toggleLoadShipmentModal() {
      this.loadShipmentModalOpen = !this.loadShipmentModalOpen;
    },
    closeConsolidatedModal() {
      this.consolidatedOrdersModalOpen = false;
    },
    updateItn(value) {
      this.orderInfo.carrier_info.international_itn = value;
    },
    createShipment() {
      const csrfToken = document.getElementsByTagName('meta')[6].content;
      this.loadingShipment = true;
      const fd = this.freightData();
      this.$http({
        method: 'post',
        url: `${window.location.origin}/create_integrated_shipments`,
        headers: { 'X-CSRF-Token': csrfToken },
        data: fd,
      })
        .then((result) => {
          this.shipmentModalOpen = true;
          this.shipmentInfo = result.data.result;
          this.loadingShipment = false;
          this.orderInfo = null;
          this.savedStates = result.data.saved_states;
          this.orderNumbers = [{ number: null }];
          window.setTimeout(() => {
            this.shipmentModalOpen = false;
          }, 2000);
        })
        .catch((error) => {
          this.setErrorMessage(error.response.data.message);
        });
    },
    toggleStateModal() {
      this.saveStateModalOpen = !this.saveStateModalOpen;
    },
    rateSelected(carrierId, serviceId, deliveryDate, shipDate) {
      this.ratesMenuOpen = false;
      this.updateCarrier(carrierId, serviceId);
      this.orderInfo.special_items.formatted_deliver_by_date = deliveryDate;
      this.orderInfo.special_items.formatted_ship_date = shipDate;
      if (this.freightData().return_label === true) {
        this.getReturnRates();
      }
    },
    returnRateSelected(carrierId, serviceId, deliveryDate, shipDate) {
      this.returnRatesMenuOpen = false;
      this.loadingReturnRatesOpen = false;
      this.loadingReturnRates = false;
      this.loadingRates = false;
      this.updateReturnCarrier(carrierId, serviceId);
      // this.orderInfo.special_items.formatted_deliver_by_date = deliveryDate;
      // this.orderInfo.special_items.formatted_ship_date = shipDate;
    },
    closeTestResponseModal() {
      this.testResponseModalOpen = false;
    },
    closeRatesModal() {
      this.ratesMenuOpen = false;
    },
    closeReturnRatesModal() {
      this.returnRatesMenuOpen = false;
    },
    closeShipmentsModal() {
      this.shipmentModalOpen = false;
    },
    updateDuty(value) {
      this.orderInfo.carrier_info.international_duty = value;
    },
    updateDutyAccount(value) {
      this.orderInfo.carrier_info.international_duty_account = value;
    },
    updateDutyPostalCode(value) {
      this.orderInfo.carrier_info.international_duty_postal_code = value;
    },
    updateDutyCountryCode(value) {
      this.orderInfo.carrier_info.international_duty_country_code = value;
    },
    validateInternational() {
      const internationalInfo = this.orderInfo.carrier_info;
      return;
      internationalInfo.description === '' ||
        internationalInfo.international_value === 0;
    },
    getRates() {
      const csrfToken = document.getElementsByTagName('meta')[6].content;
      this.loadingRates = true;
      this.$http({
        method: 'post',
        url: `${window.location.origin}/integrated_shipment_rates`,
        headers: { 'X-CSRF-Token': csrfToken },
        data: this.freightData(),
      })
        .then((result) => {
          this.rates = result.data.rates;
          this.ratesMenuOpen = true;
          this.loadingRates = false;
          this.errored = false;
        })
        .catch((error) => {
          this.rates = [];
          this.setErrorMessage(error.response.data.message);
          this.ratesMenuOpen = false;
          this.loadingRates = false;
        });
    },
    getReturnRates() {
      const csrfToken = document.getElementsByTagName('meta')[6].content;
      this.loadingReturnRatesOpen = true;
      this.loadingReturnRates = true;
      this.loadingRates = true;
      const request = this.returnFreightData();
      this.$http({
        method: 'post',
        url: `${window.location.origin}/integrated_shipment_rates`,
        headers: { 'X-CSRF-Token': csrfToken },
        data: request,
      })
        .then((result) => {
          this.loadingReturnRatesOpen = false;
          this.loadingRates = false;
          this.errored = false;
          this.rates = result.data.rates;
          const rateIds = this.rates.map(rate => rate.carrier_service_id);
          if (!rateIds.includes(this.orderInfo.carrier_info.service)) {
            this.returnRatesMenuOpen = true;
          }
        })
        .catch((error) => {
          this.rates = [];
          this.setErrorMessage(error.response.data.message);
          this.loadingReturnRatesOpen = false;
          this.returnRatesMenuOpen = false;
          this.loadingRates = false;
        });
    },
    ordersSelected(orders) {
      const orderNumbers = orders.map((order, i) => {
        return order.order_number;
      });
      if (!this.stationId) {
        this.setErrorMessage('Please select a station.');
      } else {
        this.sendOrderRequest(orderNumbers.join(','), this.stationId);
        this.consolidatedOrdersModalOpen = false;
        this.orderNumbers = orderNumbers.map((number) => {
          return {
            number: number,
          };
        });
      }
    },
    updateUnitPrice(value) {
      this.orderInfo.carrier_info.unit_price = value;
    },
    updateBoxType(boxId, packagingId) {
      const box = this.findItem(this.orderInfo.ship_units, boxId);
      const boxType = this.findItem(
        this.orderInfo.box_types,
        parseInt(packagingId)
      );
      if (!boxType) {
        box.box_type = '';
        box.length = 0;
        box.width = 0;
        box.height = 0;
      } else {
        box.box_type = boxType.name;
        box.length = boxType.length;
        box.height = boxType.height;
        box.width = boxType.width;
      }
      this.getWeight(boxId);
    },
    moveItem(itemId, oldBoxId, newBoxId) {
      let oldBox = this.orderInfo.ship_units.find((box) => box.id == oldBoxId);
      let item = oldBox.items.splice(
        oldBox.items.findIndex((item) => item.id === itemId),
        1
      )[0];
      let newBox = this.orderInfo.ship_units.find((box) => box.id == newBoxId);
      newBox.items.push(item);
    },
    updateLength(value, unitId) {
      const box = this.findItem(this.orderInfo.ship_units, unitId);
      box.length = value;
    },
    updateWidth(value, unitId) {
      const box = this.findItem(this.orderInfo.ship_units, unitId);
      box.width = value;
    },
    updateHeight(value, unitId) {
      const box = this.findItem(this.orderInfo.ship_units, unitId);
      box.height = value;
    },
    updatePhone(value) {
      this.orderInfo.ship_to.phone_number = value;
    },
    updateCurrency(value) {
      this.orderInfo.carrier_info.currency = value;
    },
    updateDescription(value) {
      this.orderInfo.carrier_info.description = value;
    },
    updateWeight(value, boxId) {
      const box = this.findItem(this.orderInfo.ship_units, boxId);
      if (parseFloat(value) > 150) {
        this.setErrorMessage('Weight cannot exceed 150 lbs!');
        box.weight = 150;
      } else {
        box.weight = parseFloat(value);
      }
    },
    translateOrderNumbers(orderNumbers) {
      return orderNumbers
        .map((number) => {
          return number.number;
        })
        .join(',');
    },
    updateInternationalValue(value) {
      this.orderInfo.carrier_info.international_value = value;
    },
    removeBox(boxId) {
      this.orderInfo.ship_units.splice(
        this.orderInfo.ship_units.findIndex((item) => item.id === boxId),
        1
      );
    },
    getWeight(boxId) {
      const box = this.orderInfo.ship_units.find((box) => box.id === boxId);
      this.loadingWeight = box.id;
      this.$http
        .get(`${window.location.origin}/integrated_weight/${this.stationId}`)
        .then((result) => {
          this.loadingWeight = null;
          this.errored = false;
          this.loading = false;
          box.weight = result.data.weight;
        })
        .catch((error) => {
          this.setErrorMessage(error.response.data.message);
        });
    },
    selectedItem(boxId) {
      this.selectedBox = boxId;
    },
    updateAtn(value) {
      this.orderInfo.ship_to.contact_name = value;
    },
    addBox(id) {
      const emptyBox = {
        box_type: '',
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        id: id,
        items: [],
      };
      this.orderInfo.ship_units.push(emptyBox);
    },
    addRow(boxId, itemId, newId) {
      const box = this.findItem(this.orderInfo.ship_units, boxId);
      const item = this.findItem(box.items, itemId);
      const itemIndex = box.items.findIndex((item) => item.id === itemId) + 1;
      if (box && item) {
        const newItem = {
          id: newId,
          item_number: item.item_number,
          description: item.description,
          quantity: item.quantity,
          ship_unit_xid: item.ship_unit_xid,
          line_number: item.line_number,
          editable: true,
        };
        box.items.splice(itemIndex, 0, newItem);
      }
    },

    updateRow(boxId, originalItemId, newItemId, splitQuantity) {
      const box = this.findItem(this.orderInfo.ship_units, boxId);
      const originalItem = this.findItem(box.items, originalItemId);
      const newItem = this.findItem(box.items, newItemId);
      const roundedQuantity = this.calculateQuantity(
        splitQuantity,
        originalItem.quantity
      );
      if (box && newItem && originalItem) {
        this.splitQuantities(
          roundedQuantity,
          newItem,
          box,
          newItemId,
          originalItemId,
          originalItem
        );
      }
      this.selectedBox = null;
    },

    splitQuantities(
      roundedQuantity,
      newItem,
      box,
      newItemId,
      originalItemId,
      originalItem
    ) {
      const invalidSplit =
        roundedQuantity >= newItem.quantity || roundedQuantity <= 0;
      if (invalidSplit) {
        this.removeTempRow(box, newItemId);
      } else {
        this.splitRow(
          newItem,
          box,
          newItemId,
          originalItem,
          originalItemId,
          roundedQuantity
        );
      }
    },

    splitRow(
      newItem,
      box,
      newItemId,
      originalItem,
      originalItemId,
      roundedQuantity
    ) {
      newItem.editable = false;
      newItem.id = originalItemId.split('#')[0] + '#' + this.createRandomId();
      newItem.quantity = parseFloat(roundedQuantity);
      const reducedQuantity = this.round(
        originalItem.quantity - roundedQuantity,
        2
      );
      originalItem.quantity = reducedQuantity;
    },

    round(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    },

    removeTempRow(box, newItemId) {
      const itemIndex = box.items.findIndex((item) => item.id === newItemId);
      box.items.splice(itemIndex, 1);
    },

    calculateQuantity(splitQuantity, quantity) {
      if (quantity > 1) {
        return Math.round(splitQuantity);
      } else {
        return Math.round(splitQuantity * 100) / 100.0;
      }
    },
    cancelUpdate(boxId, itemId) {
      const box = this.findItem(this.orderInfo.ship_units, boxId);
      const item = this.findItem(box.items, itemId);
      const itemIndex = box.items.findIndex((item) => item.id == itemId);
      if (box && item) {
        box.items.splice(itemIndex, 1);
      }
    },
    changeCarrier(value) {
      const carrierData = this.carrierOptions.find(
        (carrier) => carrier.carrier.id == value
      );
      this.orderInfo.carrier_info.signature = '';
      this.orderInfo.carrier_info.carrier = value;
      this.selectedCarrier = carrierData;

      this.setDefaultForService();
      this.setDefaultForAccountNumber();
    },
    changeServiceGroup(value) {
      this.serviceGroupId = value;
    },
    changeService(id, name) {
      this.orderInfo.carrier_info.service = id;
      const foundService = this.selectedCarrier.carrier_services.find(
        (service) => {
          return service.id == id;
        }
      );
      this.orderInfo.carrier_info.service_name = foundService.description;
      // this.orderInfo.carrier_info.return_service = id;
      // this.orderInfo.carrier_info.return_service_name = foundService.description;
    },
    changeReturnService(id, name) {
      this.$set(this.orderInfo.carrier_info, 'return_service', id);
      const foundService = this.selectedCarrier.carrier_services.find(
        (service) => {
          return service.id == id;
        }
      );
      // this.orderInfo.carrier_info.service_name = foundService.description;
      this.orderInfo.carrier_info.return_service_name = foundService.description;
    },
    changeAccount(value) {
      this.orderInfo.carrier_info.payment_type = value;
    },
    changeAccountNumber(value) {
      this.orderInfo.carrier_info.account_number = value;
    },
    changeThirdPartyAccountNumber(value) {
      this.orderInfo.carrier_info.third_party_account_number = value;
    },
    changeSignature(value) {
      this.orderInfo.carrier_info.signature = value;
    },
    changeEmail(value) {
      this.orderInfo.carrier_info.return_email = value;
    },
    changeReturnLabel(value) {
      this.orderInfo.carrier_info.return_label = value;
    },
    changeSaturdayDelivery(value) {
      this.orderInfo.carrier_info.saturday_delivery = value;
    },
    changeInsurance(value) {
      this.orderInfo.carrier_info.insurance = value;
    },
    updateCarrier(value, serviceId) {
      const carrierData = this.carrierOptions.find(
        (carrier) => carrier.carrier.id == value
      );
      const service = carrierData.carrier_services.find(
        (service) => service.id === serviceId
      );
      this.selectedCarrier = carrierData;
      window.setTimeout(() => {
        this.changeService(service.id, service.description);
      });
      this.orderInfo.carrier_info.carrier = value;
      this.setDefaultForAccountNumber();
    },
    updateReturnCarrier(value, serviceId) {
      const carrierData = this.carrierOptions.find(
        (carrier) => carrier.carrier.id == value
      );
      const service = carrierData.carrier_services.find(
        (service) => service.id === serviceId
      );
      window.setTimeout(() => {
        this.changeReturnService(service.id, service.description);
      });
    },
    findItem(array, id) {
      return array.find((item) => item.id === id);
    },
    setDefaultForService(carrierData) {
      if (this.selectedCarrier.carrier_defaults.carrier_service_id !== null) {
        const service = this.selectedCarrier.carrier_services.find(
          (service) =>
            service.id ===
            this.selectedCarrier.carrier_defaults.carrier_service_id
        );
        this.orderInfo.carrier_info.service = this.selectedCarrier.carrier_defaults.carrier_service_id;
        this.orderInfo.carrier_info.service_name = service.description;

        // this.orderInfo.carrier_info.return_service = this.selectedCarrier.carrier_defaults.carrier_service_id;
        // this.orderInfo.carrier_info.return_service_name = service.description;
      } else {
        this.orderInfo.carrier_info.service = null;
      }
    },
    setDefaultForAccountNumber(carrierData) {
      if (this.selectedCarrier.account_number) {
        this.orderInfo.carrier_info.account_number = this.selectedCarrier.account_number;
      } else {
        this.orderInfo.carrier_info.account_number = '';
      }
    },
    returnFreightData() {
      const fData = this.freightData();
      const ship_from_company_name = fData.ship_from_company_name
      const ship_from_address1 = fData.ship_from_address1
      const ship_from_address2 = fData.ship_from_address2
      const ship_from_location_code = fData.ship_from_location_code
      const ship_from_city = fData.ship_from_city
      const ship_from_state = fData.ship_from_state
      const ship_from_zip = fData.ship_from_zip
      const ship_from_country = fData.ship_from_country

      const ship_to_location_code = fData.ship_to_location_code
      const ship_to_company_name = fData.ship_to_company_name
      // const ship_to_attn_name = fData.ship_to_attn_name
      const ship_to_address1 = fData.ship_to_address1
      const ship_to_address2 = fData.ship_to_address2
      const ship_to_city = fData.ship_to_city
      const ship_to_state = fData.ship_to_state
      // const ship_to_phone_number = fData.ship_to_phone_number
      const ship_to_zip = fData.ship_to_zip
      const ship_to_country = fData.ship_to_country

      fData.ship_from_company_name = ship_to_company_name
      fData.ship_from_address1 = ship_to_address1
      fData.ship_from_address2 = ship_to_address2
      fData.ship_from_location_code = ship_to_location_code
      fData.ship_from_city = ship_to_city
      fData.ship_from_state = ship_to_state
      fData.ship_from_zip = ship_to_zip
      fData.ship_from_country = ship_to_country

      fData.ship_to_company_name = ship_from_company_name
      fData.ship_to_address1 = ship_from_address1
      fData.ship_to_address2 = ship_from_address2
      fData.ship_to_location_code = ship_from_location_code
      fData.ship_to_city = ship_from_city
      fData.ship_to_state = ship_from_state
      fData.ship_to_zip = ship_from_zip
      fData.ship_to_country = ship_from_country

      fData.return_rate = true

      return fData;
    },
    freightData() {
      const order = this.orderInfo;
      return {
        original_order_data: order.original_order_data,
        order_numbers: order.order_numbers,
        station_id: this.stationId,
        service_group_id: this.serviceGroupId,
        location_code: order.location.name,
        carrier_id: order.carrier_info.carrier,
        service_type_id: order.carrier_info.service,
        return_service_type_id: order.carrier_info.return_service,
        ship_from_company_name: order.ship_from.name,
        ship_from_address1: order.ship_from.address_line_1,
        ship_from_address2: order.ship_from.address_line_2,
        ship_from_location_code: order.ship_from.location_code,
        ship_from_city: order.ship_from.city,
        ship_from_state: order.ship_from.state,
        ship_from_zip: order.ship_from.zip,
        ship_from_country: order.ship_from.country,
        ship_to_location_code: order.ship_to.location_code,
        ship_to_company_name: order.ship_to.name,
        ship_to_attn_name: order.ship_to.contact_name,
        ship_to_address1: order.ship_to.address_line_1,
        ship_to_address2: order.ship_to.address_line_2,
        ship_to_city: order.ship_to.city,
        ship_to_state: order.ship_to.state,
        ship_to_phone_number: order.ship_to.phone_number,
        ship_to_zip: order.ship_to.zip,
        insurance: order.carrier_info.insurance,
        ship_to_country: order.ship_to.country,
        payment_type: order.carrier_info.payment_type,
        options_signature: order.carrier_info.signature,
        return_label: order.carrier_info.return_label,
        ship_date: order.special_items.formatted_ship_date,
        delivery_date: order.special_items.formatted_deliver_by_date,
        return_email: order.carrier_info.return_email,
        packages: this.ship_units(),
        saturday_delivery: order.carrier_info.saturday_delivery,
        account_number: order.carrier_info.account_number,
        third_party_account_number:
          order.carrier_info.third_party_account_number,
        currency: order.carrier_info.currency,
        description: order.carrier_info.description,
        inter_payment_type: order.carrier_info.international_duty,
        itn: order.carrier_info.international_itn,
        itn_postal: order.carrier_info.international_duty_postal_code,
        itn_country_code: order.carrier_info.international_duty_country_code,
        itn_duty_account: order.carrier_info.international_duty_account,
        amount: order.carrier_info.international_value,
        unit_price: order.carrier_info.unit_price,
        inco_term_gid: order.carrier_info.inco_term_gid,
      };
    },
    ship_units() {
      return this.orderInfo.ship_units.map((unit) => {
        return {
          id: unit.id,
          items: unit.items,
          length: Math.round(unit.length),
          width: Math.round(unit.width),
          height: Math.round(unit.height),
          ref1_value: this.determineValue(),
          ref1_code: this.settings.ref_1_code,
          weight: unit.weight,
        };
      });
    },
    determineValue() {
      switch (this.settings.ref_1_value) {
        case 'delivery_number':
          return this.orderNumbers
            .map((num) => {
              return num.number.toUpperCase();
            })
            .join(', ');
          break;
        default:
          return null;
      }
    },
    setErrorMessage(message) {
      this.loading = false;
      this.loadingRates = false;
      this.loadingWeight = false;
      this.loadingShipment = false;
      this.loadingConsolidatedOrders = false;
      this.errored = true;
      this.errorMessage = message;
      window.setTimeout(() => {
        this.errored = false;
        this.errorMessage = '';
      }, 5000);
    },
    sendTestOrderRequest(numbers, stationId) {
      this.loading = true;
      this.$http
        .get(
          `${window.location.origin}/integrated_shipment_info_test/${numbers}/${stationId}`
        )
        .then((result) => {
          console.log(result.data);
          this.testResponse = JSON.stringify(result.data);
          this.testResponseModalOpen = true;
        })
        .catch((error) => {
          this.testResponseModalOpen = false;
          this.setErrorMessage(error);
        });
    },
    sendOrderRequest(numbers, stationId) {
      this.loading = true;
      this.$http
        .get(
          `${window.location.origin}/integrated_shipment_info/${numbers}/${stationId}`
        )
        .then((result) => {
          this.orderInfo = result.data;
          this.carrierOptions = result.data.carriers;
          this.errored = false;
          this.loading = false;
          this.selectedCarrier = result.data.carriers.find(
            (carrier) => carrier.carrier.id === result.data.carrier_info.carrier
          );
        })
        .catch((error) => {
          this.setErrorMessage(error.response.data.message);
        });
    },
  },
};
</script>

<style scoped>
.container-top {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding: 20px 0;
  height: 320px;
}

.container-bottom {
  display: flex;
  justify-content: space-between;
}

.shipments-container {
  display: block;
  width: 100%;
}

.complete-form-actions {
  margin-right: 2rem;
  margin-top: 1rem;
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 2rem;
}

.btn-primary {
  float: right;
  margin-right: 5rem;
  font-size: 1rem;
}

.ship-units {
  position: relative;
  box-sizing: border-box;
  border: solid 1px black;
}
</style>
